// extracted by mini-css-extract-plugin
export var redoItem = "_kk-1";
export var redoTrigger = "_kk-0";